import MetricsTable from './MetricsTable';

export default MetricsTable;
